<template>
    <show-base-template v-on:edit='openEdit()' :item='item' :errors='errors' :allowedit='true' :title='title'>
        <template v-if='item.id' v-slot:body>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.name') | capitalise }}: </div><div class="col-18"> {{item.name}}</div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="col-6">{{ $t('translations.total_users') | capitalise }}: </div>
                <div class="col-18">
                    {{stats.total_users}}
                    <a v-if='stats.total_users' :href='`/cohorts/download/${item.id}`' class='btn btn-primary btn-sm ml-2 color-white'>{{$t('translations.download_csv')}}</a>
                </div>
            </div>

            <div class="form-group d-flex align-items-center">
                <div class="align-self-start col-6">{{ $t('translations.user_imports') | capitalise }}: </div>
                <div class="col-18">
                        <div :key='user_import.id' v-for='user_import in item.user_import'>
                            <div>{{ user_import.created_at | formatDateTime }}</div>
                            <ul>
                                <li>{{ $t('translations.new_users') }}: {{ user_import.new_users }}</li>
                                <li>{{ $t('translations.bad_data_users') }}: {{ user_import.bad_data_users }}</li>
                                <li>{{ $t('translations.existing_users') }}: {{ user_import.existing_users }}</li>
                                <li>{{ $t('translations.in_other_provider_users') }}: {{ user_import.in_other_provider_users }}</li>
                            </ul>
                        </div>
                </div>
            </div>


        </template>
    </show-base-template>
</template>

<script>
	export default {
        extends: app.base.showBase,
        props: [
        ],

        data() {
            return {
                event: "cohort",
                model: "cohort",
                title: "Cohort",
                path: 'cohorts',
                route: '/api/v1/cohorts',
                allowedit: true,
                stats: {},
            };
        },
        mounted() {
            
        },
        methods: {
            loadItem() {
                this.setLoading(true);

                axios.get(this.route + `/${this.$route.params.id}/1`).then((res) => {
					this.item = res.data[this.model];
                    this.stats = res.data["stats"];

                    this.setLoading(false);
				}).catch((error) => {
                    this.setLoading(false);
                    this.handleError(error, "load");
                    this.$router.push({path: "/" + this.event + "-list"});
                });
            },
        }
    };
</script>
